module.exports = __webpack_public_path__ + "files/446289b6122e4d6e7b0e0e1e3846c0fa.png";